import AppLayout from '@pages/_layout/AppLayout';
import ArchivePointsTable from '@pages/Home/pages/Historian/pages/Archive';
import HistorianData from '@pages/Home/pages/Historian/pages/Data';
import HistorianDump from '@pages/Home/pages/Historian/pages/Dump';
import { Navigate, RouteObject } from 'react-router';
import TopBar from './TopBar';

export default [
  {
    path: 'historian',
    element: <AppLayout isNested topBar={<TopBar />} />,
    children: [
      { index: true, element: <Navigate to='data' replace /> },
      { path: 'data', element: <HistorianData /> },
      { path: 'export', element: <HistorianDump /> },
      { path: 'archive', element: <ArchivePointsTable /> },
    ],
  },
] as RouteObject[];
